import React, { useState, useEffect } from "react";
import { Modal, Spin, Row, Col, Image } from "antd";
import ImageGallery from "react-image-gallery";
import axios from "axios";
import "react-image-gallery/styles/css/image-gallery.css";

// const fallbackImage = "https://via.placeholder.com/150?text=Image+Not+Available";
const fallbackImage = "https://placehold.co/400x300/png?text=%F0%9F%93%B7+Image+Unavailable&font=roboto";


const ViewImagesModal= ({ imei, isVisible, onClose }) => {
  const [firstSetImages, setFirstSetImages] = useState([]);
  const [secondSetImages, setSecondSetImages] = useState([]);
  const [loading, setLoading] = useState(false);
const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    if (imei && isVisible) fetchImages();
  }, [imei, isVisible]);

  const fetchImages = async () => {
    setLoading(true);
    try {
      // First set (Kiosk)
      const filenames = [
        "Back.jpg",
        "Font_LightAngle1.jpg",
        "Font_LightAngle2.jpg",
        "Font_LightAngle3.jpg",
        "Font_LightAngle4.jpg",
        "Font_LightAngle5.jpg",
        "Font_LightAngle6.jpg",
        "Font_LightAngle7.jpg",
        "Font_LightAngle8.jpg",
        "Front.jpg",
        "Behind.jpg",
      ];
      const first = filenames.map((file) => {
        const url = `https://report.gearvu.io/kiosk-image/downloaded_files/${imei}/${file}`;
        return {
          original: url,
          thumbnail: url,
          alt: file,
        };
      });
      setFirstSetImages(first);

      // Second set (WebDuo API)
      const response = await axios.get(
        `https://live.callcenter.buybackbooth.com/Scripts/Gearvana/CC_GetSessionFromIMEI.php?imei=${imei}`
      );
      if (response.data?.status === "success") {
        const images = response.data.data[0]?.assets?.screens[0]?.images || [];
        const second = images.map((img) => ({
          original: img.url,
          thumbnail: img.url,
          alt: `WebDuo ${img.id}`,
        }));
        setSecondSetImages(second);
      }
    } catch (err) {
      console.error("Error fetching images:", err);
    }
    setLoading(false);
  };

  const handleImageError = (e) => {
    e.target.src = fallbackImage;
    e.target.alt = "Not available";
  };
  
  useEffect(() => {
  const updateWidth = () => {
    setScreenWidth(window.visualViewport?.width || window.innerWidth);
  };

  // Listen for all possible viewport changes
  window.addEventListener('resize', updateWidth);
  window.addEventListener('orientationchange', updateWidth);
  window.visualViewport?.addEventListener('resize', updateWidth);

  // Set initial width
  updateWidth();

  return () => {
    window.removeEventListener('resize', updateWidth);
    window.removeEventListener('orientationchange', updateWidth);
    window.visualViewport?.removeEventListener('resize', updateWidth);
  };
}, []);

return (
  <Modal
    open={isVisible}
    onCancel={onClose}
    footer={null}
    width="85%"
    getContainer={document.body} // force portal to body
    centered
    zIndex={990000}

    style={{
      top: 10,
      padding: 0,
      maxWidth: "1600px",
      // paddingLeft: screenWidth < 1200 ? "20px" : "300px",
    }}
    
  >
    {loading ? (
      <div
        style={{
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
      </div>
    ) : (
      <Row gutter={[16, 16]}>
        {/* Left Column - KIOSK */}
        <Col xs={24} md={24} lg={12}>
          <h3 style={{ textAlign: "center", marginBottom: 12 }}>
            Kiosk Images
          </h3>
          <div
            style={{
              width: "90%",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              background: "#fff",
              borderRadius: "8px",
            }}
          >
            <ImageGallery
              additionalClass="comparison-gallery kiosk-gallery"
              items={firstSetImages.map((img) => ({
                ...img,
                renderItem: () => (
                  <div
                    style={{
                      width: "100%",
                     height: document.fullscreenElement ? "100vh" : "65vh", // 👈 dynamic height

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={img.original}
                      alt={img.alt}
                      onError={handleImageError}
                      style={{
                        maxHeight: "90%",
                        maxWidth: "100%",
                        objectFit: "contain",
                        transform: "rotate(270deg)", // rotate kiosk images
                        transformOrigin: "center center",
                      }}
                    />
                  </div>
                ),
                 
                 renderThumbInner: () => (
                     <div
                    style={{
                      width: "100%",
                     height: document.fullscreenElement ? "0vh" : "20vh", // 👈 dynamic height

                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
      <img
        src={img.thumbnail}
        alt={img.alt}
        onError={handleImageError}
        style={{
          maxHeight: "90%",
                        maxWidth: "100%",
                        objectFit: "contain",
                        transform: "rotate(270deg)", // rotate kiosk images
                        transformOrigin: "center center",
        }}

      />
      </div>
    ),
                 
              }))}
              showThumbnails
              showFullscreenButton
              showPlayButton={false}
            />
          </div>
        </Col>

        {/* Right Column - WebDuo */}
        <Col xs={24} md={24} lg={12}>
          <h3 style={{ textAlign: "center", marginBottom: 12 }}>
            WebDuo Images
          </h3>
          <div
            style={{
              width: "90%",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              background: "#fff",
              borderRadius: "8px",
            }}
          >
            <ImageGallery
              additionalClass="comparison-gallery webduo-gallery"
              items={secondSetImages.map((img) => ({
                ...img,
                renderItem: () => (
                  <div
                    style={{
                      width: "100%",
                      height: document.fullscreenElement ? "100vh" : "65vh", // 👈 dynamic height
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={img.original}
                      alt={img.alt}
                      onError={handleImageError}
                      style={{
                        maxHeight: "90%",
                        maxWidth: "90%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ),
              }))}
              showThumbnails
              showFullscreenButton
              showPlayButton={false}
              
            />
          </div>
        </Col>
      </Row>
    )}

    {/* Scoped fullscreen styles */}
<style>
{`
  /* Fullscreen root */
  .comparison-gallery:fullscreen,
  .comparison-gallery:-webkit-full-screen,
  .comparison-gallery:-moz-full-screen,
  .comparison-gallery:-ms-fullscreen {
    background: #000 !important;
    width: 100vw !important;
    height: 100vh !important;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  /* Hide extra UI in fullscreen */
  .comparison-gallery:fullscreen .image-gallery-thumbnails,
  .comparison-gallery:fullscreen .image-gallery-play-button,
  .comparison-gallery:fullscreen .image-gallery-index {
    display: none !important;
  }

  /* Force content to stretch */
  .comparison-gallery:fullscreen .image-gallery-content,
  .comparison-gallery:fullscreen .image-gallery-slide-wrapper,
  .comparison-gallery:fullscreen .image-gallery-slide,
  .comparison-gallery:fullscreen .image-gallery-image {
    width: 100% !important;
    height: 100% !important;
  }

  /* Images scale nicely */
  .comparison-gallery:fullscreen img,
  .comparison-gallery:-webkit-full-screen img,
  .comparison-gallery:-moz-full-screen img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important; /* change to 'cover' if you want cropping */
  }
  
  
`}
</style>

  </Modal>
);

};

export default ViewImagesModal;





// const ImprovedModal = ({ isVisible, onClose, loading, firstSetImages, secondSetImages }) => {
//   // Custom render function for better fullscreen experience
//   const renderCustomImage = (item, isKiosk = false) => ({
//     original: item.original || item.originalUrl || item.url || item.src,
//     thumbnail: item.thumbnail || item.thumbnailUrl || item.original || item.originalUrl || item.url || item.src,
//     renderItem: () => (
//       <div 
//         className="custom-gallery-item"
//         style={{
//           height: '70vh',
//           minHeight: '400px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backgroundColor: '#f9f9f9',
//           padding: '10px'
//         }}
//       >
//         <img
//           src={item.original || item.originalUrl || item.url || item.src}
//           alt={isKiosk ? "kiosk-img" : "webduo-img"}
//           style={{
//             maxHeight: '100%',
//             maxWidth: '100%',
//             objectFit: 'contain',
//             display: 'block',
//             transform: isKiosk ? 'rotate(270deg)' : 'none'
//           }}
//         />
//       </div>
//     )
//   });

//   return (
//     <>
//       <Modal
//         open={isVisible}
//         onCancel={onClose}
//         footer={null}
//         width="95vw"
//         centered
//         style={{
//           maxWidth: '1400px',
//           top: 20
//         }}
//         styles={{
//           body: {
//             padding: 0,
//             height: '90vh',
//             overflow: 'hidden'
//           }
//         }}
//         className="custom-image-modal"
//         getContainer={false}
//       >
//         {loading ? (
//           <div style={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center',
//             height: '400px'
//           }}>
//             <Spin size="large" />
//           </div>
//         ) : (
//           <div className="modal-content-wrapper">
            
//             {/* Left Side - KIOSK Images */}
//             <div className="image-section">
//               <h3 className="section-title">KIOSK Images</h3>
//               <div className="gallery-container">
//                 <ImageGallery
//                   items={firstSetImages.map((image) => renderCustomImage(image, true))}
//                   showThumbnails={true}
//                   showFullscreenButton={true}
//                   showPlayButton={false}
//                   thumbnailPosition="bottom"
//                   useBrowserFullscreen={true}
//                   showNav={firstSetImages.length > 1}
//                   additionalClass="custom-gallery"
//                 />
//               </div>
//             </div>

//             {/* Right Side - WebDuo Images */}
//             <div className="image-section">
//               <h3 className="section-title">WebDuo Images</h3>
//               <div className="gallery-container">
//                 {secondSetImages.length > 0 ? (
//                   <ImageGallery
//                     items={secondSetImages.map((image) => renderCustomImage(image, false))}
//                     showThumbnails={true}
//                     showFullscreenButton={true}
//                     showPlayButton={false}
//                     thumbnailPosition="bottom"
//                     useBrowserFullscreen={true}
//                     showNav={secondSetImages.length > 1}
//                     additionalClass="custom-gallery"
//                   />
//                 ) : (
//                   <div className="no-images-message">
//                     No images available for this IMEI.
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </Modal>

//       {/* Custom Styles - Scoped to this modal only */}
//    <style jsx global>{`
//   /* Only affects this specific modal */
//   .custom-image-modal .ant-modal-wrap {
//     padding-left: 200px;
//   }
  
//   .custom-image-modal .ant-modal-content {
//     height: 90vh;
//     display: flex;
//     flex-direction: column;
//   }

//   .custom-image-modal .ant-modal-body {
//     flex: 1;
//     overflow: hidden;
//   }

//   .custom-image-modal .modal-content-wrapper {
//     display: flex;
//     flex-direction: row;
//     height: 100%;
//     gap: 20px;
//     padding: 20px;
//     overflow-y: auto;
//   }

//   .custom-image-modal .image-section {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     min-width: 0;
//   }

//   .custom-image-modal .section-title {
//     margin: 0 0 15px 0;
//     text-align: center;
//     font-size: 18px;
//     font-weight: 600;
//     color: #333;
//     flex-shrink: 0;
//   }

//   .custom-image-modal .gallery-container {
//     flex: 1;
//     border: 1px solid #e8e8e8;
//     border-radius: 8px;
//     overflow: hidden;
//     background-color: #fff;
//     display: flex;
//     flex-direction: column;
//   }

//   .custom-image-modal .no-images-message {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 100%;
//     color: #666;
//     font-size: 16px;
//   }

//   /* Custom Gallery Styles - Only affects galleries inside this modal */
//   .custom-image-modal .custom-gallery .image-gallery-content {
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//   }

//   .custom-image-modal .custom-gallery .image-gallery-slide-wrapper {
//     flex: 1;
//     position: relative;
//   }

//   .custom-image-modal .custom-gallery .image-gallery-image {
//     height: 100% !important;
//     object-fit: contain;
//   }

//   /* Always hide bullets completely */
//   .custom-image-modal .image-gallery-bullets {
//     display: none !important;
//     height: 0 !important;
//     margin: 0 !important;
//     padding: 0 !important;
//   }

//   .custom-image-modal .image-gallery-fullscreen-button {
//     z-index: 4;
//   }

//   /* Thumbnails visible in normal mode */
//   .custom-image-modal .image-gallery-thumbnails-wrapper {
//     order: 2;
//     display: block !important;
//   }

//   /* Fullscreen - hide thumbnails */
//   .image-gallery:-webkit-full-screen .image-gallery-thumbnails-wrapper,
//   .image-gallery:-moz-full-screen .image-gallery-thumbnails-wrapper,
//   .image-gallery:fullscreen .image-gallery-thumbnails-wrapper {
//     display: none !important;
//   }

//   /* Fullscreen improvements */
//   .image-gallery:-webkit-full-screen,
//   .image-gallery:-moz-full-screen,
//   .image-gallery:fullscreen {
//     background-color: rgba(0, 0, 0, 0.9) !important;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   .image-gallery:-webkit-full-screen .image-gallery-content,
//   .image-gallery:-moz-full-screen .image-gallery-content,
//   .image-gallery:fullscreen .image-gallery-content {
//     height: 100vh !important;
//     width: 100vw !important;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }

//   .image-gallery:-webkit-full-screen .image-gallery-slide .image-gallery-image,
//   .image-gallery:-moz-full-screen .image-gallery-slide .image-gallery-image,
//   .image-gallery:fullscreen .image-gallery-slide .image-gallery-image {
//     max-height: 100vh !important;
//     max-width: 100vw !important;
//     object-fit: contain !important;
//   }

//   /* Improve thumbnail visibility */
//   .custom-image-modal .image-gallery-thumbnails {
//     padding: 10px 5px 5px 5px;
//   }

//   .custom-image-modal .image-gallery-thumbnail {
//     border: 2px solid transparent;
//     border-radius: 4px;
//   }

//   .custom-image-modal .image-gallery-thumbnail.active {
//     border-color: #1890ff;
//   }

//   .custom-image-modal .image-gallery-thumbnail:hover {
//     border-color: #40a9ff;
//   }

//   /* Better navigation buttons */
//   .custom-image-modal .image-gallery-left-nav,
//   .custom-image-modal .image-gallery-right-nav {
//     color: #1890ff;
//     font-size: 24px;
//   }

//   .custom-image-modal .image-gallery-left-nav:hover,
//   .custom-image-modal .image-gallery-right-nav:hover {
//     color: #40a9ff;
//   }

//   /* Responsive Styles */
//   @media (max-width: 1200px) {
//     .custom-image-modal .ant-modal-wrap {
//       padding-left: 100px;
//     }
//   }

//   @media (max-width: 1024px) {
//     .custom-image-modal .modal-content-wrapper {
//       flex-direction: column;
//       gap: 15px;
//       padding: 15px;
//       overflow-y: auto;
//       max-height: 90vh;
//     }

//     .custom-image-modal .custom-gallery-item {
//       height: 50vh !important;
//       min-height: 300px !important;
//     }
//   }

//   @media (max-width: 768px) {
//     .custom-image-modal .ant-modal-wrap {
//       padding-left: 40px;
//     }
    
//     .custom-image-modal .ant-modal-content {
//       margin: 5px !important;
//       height: 95vh !important;
//     }

//     .custom-image-modal .modal-content-wrapper {
//       padding: 10px;
//       gap: 10px;
//       overflow-y: auto;
//       max-height: 95vh;
//     }

//     .custom-image-modal .section-title {
//       font-size: 16px;
//     }

//     .custom-image-modal .custom-gallery-item {
//       height: 40vh !important;
//       min-height: 250px !important;
//     }

//     .custom-image-modal .image-gallery-thumbnails .image-gallery-thumbnail {
//       width: 60px !important;
//       height: 40px !important;
//     }
//   }

//   @media (max-width: 480px) {
//     .custom-image-modal .ant-modal-wrap {
//       padding-left: 0px;
//     }
    
//     .custom-image-modal .custom-gallery-item {
//       height: 35vh !important;
//       min-height: 200px !important;
//     }

//     .custom-image-modal .modal-content-wrapper {
//       padding: 8px;
//       overflow-y: auto;
//       max-height: 95vh;
//     }

//     .custom-image-modal .section-title {
//       font-size: 14px;
//       margin-bottom: 10px;
//     }
//   }
// `}</style>

//     </>
//   );
// };



//     onCancel={onClose}
//     footer={null}
//     width="70%"
//     centered
//     style={{
//       maxWidth: '1200px',
//     }}
//     styles={{
//       body: {
//         padding: 0,
//         height: '85vh',
//         overflow: 'hidden'
//       }
//     }}
//   >
//     {loading ? (
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center',
//         height: '400px'
//       }}>
//         <Spin size="large" />
//       </div>
//     ) : (
//       <div style={{
//         display: 'flex',
//         flexDirection: 'row',
//         height: '85vh',
//         gap: '20px',
//         padding: '20px'
//       }}>
        
//         {/* Left Side - KIOSK Images */}
//         <div style={{
//           flex: '1 1 50%',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           minWidth: '300px'
//         }}>
//           <h3 style={{ 
//             margin: '0 0 20px 0', 
//             textAlign: 'center',
//             fontSize: '18px',
//             fontWeight: '600',
//             color: '#333'
//           }}>
//             KIOSK Images
//           </h3>

//           <div style={{
//             width: '100%',
//             height: 'calc(100% - 60px)',
//             maxWidth: '500px',
//             border: '1px solid #e8e8e8',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             backgroundColor: '#fff'
//           }}>
//             <ImageGallery
//               items={firstSetImages.map((image) => ({
//                 original: image.original || image.originalUrl || image.url || image.src,
//                 thumbnail: image.thumbnail || image.thumbnailUrl || image.original || image.originalUrl || image.url || image.src,
//                 renderItem: () => (
//                   <div style={{
//                     height: '60vh',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     backgroundColor: '#f9f9f9'
//                   }}>
//                     <img
//                       src={image.original || image.originalUrl || image.url || image.src}
//                       alt="kiosk-img"
//                       style={{
//                         height: '100%',
//                         width: 'auto',
//                         width: '100%',
//                         objectFit: 'contain',
//                         display: 'block',
//                         transform: 'rotate(90deg)'
//                       }}
//                     />
//                   </div>
//                 )
//               }))}
//               showThumbnails={true}
//               showFullscreenButton={true}
//               showPlayButton={false}
//               thumbnailPosition="bottom"
//             />
//           </div>
//         </div>

//         {/* Right Side - WebDuo Images */}
//         <div style={{
//           flex: '1 1 50%',
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           minWidth: '300px'
//         }}>
//           <h3 style={{ 
//             margin: '0 0 20px 0', 
//             textAlign: 'center',
//             fontSize: '18px',
//             fontWeight: '600',
//             color: '#333'
//           }}>
//             WebDuo Images
//           </h3>

//           <div style={{
//             width: '100%',
//             height: 'calc(100% - 60px)',
//             maxWidth: '500px',
//             border: '1px solid #e8e8e8',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             backgroundColor: '#fff'
//           }}>
//             {secondSetImages.length > 0 ? (
//               <ImageGallery
//                 items={secondSetImages.map((image) => ({
//                   original: image.original || image.originalUrl || image.url || image.src,
//                   thumbnail: image.thumbnail || image.thumbnailUrl || image.original || image.originalUrl || image.url || image.src,
//                   renderItem: () => (
//                     <div style={{
//                       height: '60vh',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       backgroundColor: '#f9f9f9'
//                     }}>
//                       <img
//                         src={image.original || image.originalUrl || image.url || image.src}
//                         alt="webduo-img"
//                         style={{
//                           height: '100%',
//                           width: 'auto',
//                           maxWidth: '100%',
//                           objectFit: 'contain',
//                           display: 'block'
//                         }}
//                       />
//                     </div>
//                   )
//                 }))}
//                 showThumbnails={true}
//                 showFullscreenButton={true}
//                 showPlayButton={false}
//                 thumbnailPosition="bottom"
//               />
//             ) : (
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 height: '100%',
//                 color: '#666',
//                 fontSize: '16px'
//               }}>
//                 No images available for this IMEI.
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     )}

//     {/* Responsive Mobile Layout */}
//     <style jsx>{`
//       @media (max-width: 768px) {
//         .ant-modal-content {
//           margin: 10px !important;
//         }
//       }
//     `}</style>
//   </Modal>
// );